<!-- Name -->
<span
    class="rounded-lg border-s-4 bg-slate-200 p-2 text-slate-600"
    [ngClass]="nameBorderClass"
>
    {{ 'translate_' + item.name | translate }}
    <ng-content></ng-content>
</span>

<!-- Is enabled -->
<app-toggle-switch
    [(ngModel)]="item.isEnabled"
    (valueChange)="onEnabledChange($event)"
    [label]="'translate_is_enabled_qm' | translate"
></app-toggle-switch>

<!-- Is required -->
@if (showRequired) {
    <app-toggle-switch
        [(ngModel)]="item.isRequired"
        [label]="'translate_is_required_qm' | translate"
        [disabled]="isRequiredToggleDisabled"
    ></app-toggle-switch>
}

<!-- Empty placeholder to keep cols-3 alignment when Required? is hidden -->
@if (!showRequired && keepRequiredSlot) {
    <span></span>
}
